import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "places",
    initialState: [],
    reducers: {
        set: (state, action) => action.payload,
    },
});
